module.exports = __webpack_public_path__ + "front/img/p2.a001afc3.jpg";